import useRead from "../../useRead";

const useGetIngredient = ({ ingredientId, onSuccess } = {}) => {
  const { data, paramsObject, setGetListParams } = useRead({
    url: "ingredients/view",
    initialData: ingredientId ? { ingredient_id: ingredientId } : {},
    method: "GET",
    enabled: !!ingredientId,
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data);
      }
    },
  });

  return {
    data,
    paramsObject,
    setGetListParams,
  };
};

export default useGetIngredient;
